import {
    Box,
    Button,
    Typography,
} from '@mui/material'
import Banner1 from '../../../assets/motor-vehicle/privatecar-banner.png'
import Banner2 from '../../../assets/motor-vehicle/comprehensive-banner.png'
import { INSURANCE_MOTOR_LINK,  INSURANCE_CAR_LINK} from '../../../common/config'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMInsuranceRenewal: React.FC = () => {

    const { t } = useTranslation()

    // 去购买保险
    const buyInsurance = (link: string) => {
        window.open(link)
    }

    const data = [
        {
            'backgroundImage': Banner1,
            'title': t('t260'),
            'content': t('t266'),
            'data': [
                t('t261'),
                t('t262'),
                t('t263'),
                t('t264'),
                t('t265')
            ],
            'buttonTitle': t('t267'),
            'link': INSURANCE_CAR_LINK,
        },
        {
            'backgroundImage': Banner2,
            'title': t('t268'),
            'content': '',
            'data': [
                t('t269'),
                t('t270'),
                t('t271'),
                t('t272'),
            ],
            'buttonTitle': t('t267'),
            'link': INSURANCE_MOTOR_LINK,
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                flex: '1',
                display: 'flex',
                paddingLeft: '18px',
                paddingRight: '18px',
            }}>
                <Box sx={{
                    backgroundImage: `url(${data[index]['backgroundImage']})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'start',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '10px',
                }}>

                    <Box sx={{
                        width: '100%',
                        height: '100%',
                        paddingLeft: '21px',
                        paddingRight: '21px',
                        paddingTop: isTablet ? '150px' : '215px',
                        display: 'flex'
                    }}>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '10px',
                            paddingLeft: isTablet ? '20px' : '40px',
                            paddingRight: isTablet ? '20px' : '40px',
                            paddingTop: '40px',
                            paddingBottom: '40px',
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        }}>
                            <Box>

                                <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                                    {data[index]['title']}
                                </Typography>

                                {data[index]['data'].map((subItem, subIndex) => ( 
                                    renderTitleItem(subItem, subIndex)
                                ))}

                                {
                                    data[index]['content'] !== '' ? (<Typography style={{fontStyle: 'italic', fontSize: '14px' ,fontWeight: '400', color: '#6B6B6B'}} paddingTop={'14px'} paddingLeft={'8px'} >
                                        {data[index]['content']}
                                    </Typography>) : (<Box></Box>)
                                }
                            </Box>

                            <Box sx={{paddingTop: '25px', width: '100%',}}>
                                <Button 
                                    onClick={() => buyInsurance(data[index]['link'])}
                                    sx={{
                                        borderRadius: '30px',
                                        width: '100%',
                                        height: '60px',
                                        bgcolor: '#FFC107',
                                        border: '1px solid #FFC107',
                                        color: '#141F39',
                                        '&:hover': {
                                            bgcolor: '#FFC107',
                                        },
                                        textTransform: 'none',
                                    }}
                                    style={{fontSize: '16px', fontWeight: '500'}}
                                >
                                    {data[index]['buttonTitle']}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }

    const renderTitleItem = (item: string, index: number) => {
        return (
            <Typography key={index} fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'8px'} paddingTop={'24px'}>
                {item}
            </Typography>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '52px',
                paddingRight: '52px',
                paddingTop: '60px',
                backgroundColor: '#FFFDF7',
            }}
        >

            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingLeft={'100px'} paddingRight={'100px'}>
                {t('t257')}
            </Typography>
            
            <Typography fontSize={20} fontWeight={600} color={'#141F39'} textAlign={'center'} paddingTop={'20px'} paddingLeft={'120px'} paddingRight={'120px'}>
                {t('t258')} {<span style={{fontStyle: 'italic', fontSize: '20px' ,fontWeight: '500',}}>{t('t259')}</span>}
            </Typography>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '45px',
                paddingBottom: '60px',
            }}>
                {data.map((item, index) => (
                    renderItem(index)
                ))}
            </Box>
        </Box >
    )
}

// ======================= EXPORT
export default SMInsuranceRenewal
